import { render, staticRenderFns } from "./buyRecord.vue?vue&type=template&id=262b8167&scoped=true"
import script from "./buyRecord.vue?vue&type=script&lang=ts"
export * from "./buyRecord.vue?vue&type=script&lang=ts"
import style0 from "./buyRecord.vue?vue&type=style&index=0&id=262b8167&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "262b8167",
  null
  
)

export default component.exports